import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Container from '../../../Core/Container';
import Image from '../../../Core/Image';
import MultiColumnLayout from '../../Shared/MultiColumnLayout';

export const Wrapper = styled.div`
  background-color: ${themeGet('colors.neutral_1')};
`;

export const StyledContainer = styled(Container)`
  padding: 50px 0 60px;

  > h1,
  > h2,
  > h3,
  > h4,
  > h5,
  > h6 {
    text-align: center;
    margin-bottom: 52px;
  }

  > h3 {
    font-weight: 700;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    padding: 50px 45px 60px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    padding: 70px 0px 90px;

    h2 {
      font-size: 26px;
      line-height: 38px;
    }
  }

  /* Add class header styles to override sizes when chosen as tags */
  .h2 {
    font-size: 26px;
    line-height: 38px;
  }

  .h3 {
    font-weight: 700;
    line-height: 26px;
  }

  .h4 {
    font-size: 22px;
    line-height: 32px;
  }

  .h5 {
    font-size: 18px;
    line-height: 28px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xl')}) {
    padding: 70px 45px 90px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.max')}) {
    padding: 70px 90px 90px;
  }
`;

export const Columns = styled(MultiColumnLayout)``;

export const Block = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  p {
    margin-bottom: 45px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    flex-direction: row;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    flex-direction: column;
    h2,
    .h2,
    p {
      max-width: 250px;
    }
  }
`;

export const StyledImage = styled(Image)`
  margin: 0 auto 39px;

  max-height: 144px;
  max-width: 144px;
  width: 100%;
  height: 100%;

  ${Block}.left &, ${Block}.Left & {
    margin: 0 0 39px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    margin-right: 24px;

    ${Block}.left &, ${Block}.Left & {
      margin-right: 24px;
    }
  }
  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    margin: 0 auto 39px;

    ${Block}.left &, ${Block}.Left & {
      margin: 0 0 39px;
    }
  }
`;

export const Content = styled.div`

  /* adjust content positioning based on block layout */
  margin-top: auto;
  margin-bottom: auto;
  
  ${Block}.centre &, ${Block}.Centre & {
    width: auto;
    margin-left: auto;
    margin-right: auto;
  }

  h2:first-child,
  h3:first-child,
  h4:first-child,
  h5:first-child,
  h6:first-child {
    font-weight: ${themeGet('font-weights.bold')};
    color: ${themeGet('colors.text-secondary')};
    text-align: center;

    ${Block}.left &, ${Block}.Left & {
      text-align: left;
    }

    margin-bottom: 30px;
  }

  p {
    text-align: center;
    ${Block}.left &, ${Block}.Left & {
      text-align: left;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    h2:first-child,
    h3:first-child,
    h4:first-child,
    h5:first-child,
    h6:first-child,
    p {
      text-align: center;

      ${Block}.left &, ${Block}.Left & {
        text-align: left;
      }
    }
  }
}
`;

export const Footer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-top: 10px;

  h3,
  .h3,
  h4,
  .h4 {
    margin-bottom: 30px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    margin-top: 30px;
  }
`;
